
import './style.less';

import { ViewModel as model } from './model';
import template from './template.html';

import { registerComponent } from 'Utils/engine/register-component';

registerComponent('fc-status-popper', { model, template });
